import React from "react";

import { PostHogProvider } from "posthog-js/react";
import { PropTypes } from "prop-types";
import { AuthProvider } from "./context/auth";
import { UserProvider } from "./context/user";

export default function AppProviders({ children }) {
  return (
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        defaults: "2025-05-24",
        capture_exceptions: true, // enables capturing exceptions using Error Tracking
        debug: process.env.NODE_ENV === "development",
      }}
    >
      <AuthProvider>
        <UserProvider>{children}</UserProvider>
      </AuthProvider>
    </PostHogProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.any,
};
